import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { UseGlobellogin } from "./Logincontaxt.jsx/Logincontex";
import { NavLink } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { BASE_URL } from "../Config/Config";
import OrderHistory from "./OrderHistory";
import { FiPlus, FiEdit } from "react-icons/fi"; // Feather Icons
import SubLoading from "../ALL CSS/Loading";

const Profile = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [data, setdata] = useState([]);
  const [file, setFile] = useState(null);
  const [Loading, setLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const { setsuccessfully, refresh, setrefresh, userName, user_img, seterrormessage } = UseGlobellogin();

  const [formData, setFormData] = useState({
    first_name: data?.first_name || "",
    mobile_no: data?.mobile_no || "",
    email: data?.email || "",
    user_gender: data?.user_gender || "",
  });

  useEffect(() => {
    setFormData({
      first_name: data?.first_name || "",
      mobile_no: data?.mobile_no || "",
      email: data?.email || "",
      user_gender: data?.user_gender || "",
    });
  }, [data]);

  const email = localStorage.getItem("userEmail")
  const User_id = localStorage.getItem("user_id");

  const handleInputChange = (e) => {
    const { name, value, } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }

  useEffect(() => {
    const fetchprofail = async (User_id) => {
      try {
        const User_id = localStorage.getItem("user_id");
        const response = await fetch(`${BASE_URL}/usermaster/${User_id}`);
        const result = await response.json();
        if (response.ok) {
          setdata(result.data);
        } else {
          console.error("Failed profail data:", result.message);
        }
      } catch (error) {
        console.error("Error fetching profail data:", error);
      }
    };
    fetchprofail(User_id);
  }, [refresh]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.first_name?.trim() ||
      !formData.mobile_no?.trim() ||
      !formData.user_gender
    ) {
      seterrormessage("Please fill out all fields");
      setTimeout(() => {
        seterrormessage("")
      }, 3000);
      return;
    }
    setLoading(true);
    const formDataToSend = new FormData();
    const payload = preparePayload();

    for (const key in payload) {
      formDataToSend.append(key, payload[key]);
    }
    try {
      if (file) {
        formDataToSend.append("user_img", file);
      }

      const User_id = localStorage.getItem("user_id");
      const response = await fetch(`${BASE_URL}/usermaster/${User_id}/`, {
        method: "PUT",

        body: formDataToSend,
      });
      const responseData = await response.json();

      if (response.ok) {
        setsuccessfully(responseData.message);
        setTimeout(() => setsuccessfully(""), 7000);
        setIsEditing(false)
        setrefresh(!refresh);

      } else {
        setsuccessfully(responseData.message);
      }

    } catch (error) {
      console.log(error);
    }
    finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);

    if (selectedFile) {
      const previewURL = URL.createObjectURL(selectedFile);
      setPreviewImage(previewURL);
    }
  };




  const preparePayload = () => {
    const payload = {};

    // Always allow updating name and gender
    if (formData.first_name?.trim()) {
      payload.first_name = formData.first_name.trim();
    }

    if (formData.user_gender) {
      payload.user_gender = formData.user_gender;
    }

    // Conditionally add mobile or email based on login method
    if (formData.mobile_no?.trim()) {
      payload.mobile_no = formData.mobile_no.trim();
    }

    // ✅ Always include email if it's present
    if (formData.email?.trim()) {
      payload.email = formData.email.trim();
    }

    return payload;
  };
useEffect(() => {
  if (formData.email && formData.email.trim() !== "") {
    localStorage.setItem("userEmail", formData.email.trim());
  }
}, [formData.email]);


  const loginMethod = localStorage.getItem("login_method");
  return (
    <>

      <Wrapper>
        <Container className="bg-light">
          <div> <h2 className="text-center text-primary"> Personal Information </h2></div>
          <div
            style={{
              maxWidth: "900px",
              margin: "auto",
              padding: "1rem",
              display: "flex",
              flexWrap: "wrap",
              gap: "2rem",
              justifyContent: "center",
              alignItems: "center",
              background: "white",
              borderRadius: "12px",
              boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)"
            }}

          >
            {/* Profile Image */}

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
              {/* Profile Image */}
              <div style={{ position: "relative", width: "120px", height: "120px" }}>
                <img
                  src={
                    previewImage
                      ? previewImage
                      : data?.user_img
                        ? `${BASE_URL}${data.user_img}`
                        : "assets/img/profail.png"
                  }
                  alt="User"
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #007bff",
                  }}
                />


                {/* Upload Icon (visible when editing) */}
                {isEditing && (
                  <>
                    <label
                      htmlFor="profileImageUpload"
                      style={{
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        backgroundColor: "#007bff",
                        borderRadius: "50%",
                        padding: "6px",
                        cursor: "pointer",
                        boxShadow: "0 0 5px rgba(0,0,0,0.3)",
                      }}
                    >
                      <FiPlus color="#fff" size={16} />
                    </label>
                    <input
                      type="file"
                      id="profileImageUpload"
                      name="profailimage"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />
                  </>
                )}
              </div>
              <p
                className="fw-semibold mt-2"
                style={{
                  fontSize: "1.1rem",
                  margin: 0,
                  textTransform: "capitalize"
                }}
              >
                {userName ? userName : data?.first_name}
              </p>

            </div>


            {/* Profile Info */}
            <div style={{ flex: 1, minWidth: "280px" }}>
              <div className="row g-3">
                {/* {loginMethod === "email" && ( */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    className="form-control"
                    placeholder="Enter the email"
                    disabled={loginMethod === "email" ? true : !isEditing} />
                </div>
                {/* )} */}

                {/* {loginMethod === "mobile" && ( */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Mobile Number</label>
                  <input
                    type="text"
                    name="mobile_no"
                    value={formData.mobile_no}
                    className="form-control"
                    disabled={loginMethod === "mobile" ? true : !isEditing} />
                </div>
                {/* )} */}

                {/* <div className="col-md-6">
      <input
        type="text"
        name="mobile_no"
        value={formData.mobile_no}
        placeholder="Phone Number"
        className="form-control"
        onChange={handleInputChange}
        disabled={!isEditing}
      />
    </div> */}



                <div className="col-md-6">
                  <label className="form-label fw-semibold">Full Name</label>
                  <input
                    type="text"
                    name="first_name"
                    value={formData.first_name}
                    placeholder="Full Name"
                    className="form-control"
                    onChange={handleInputChange}
                    disabled={!isEditing}
                  />
                </div>



                <div className="col-md-6">
                  <label className="form-label fw-semibold">Gender</label>
                  <select
                    name="user_gender"
                    value={formData.user_gender}
                    className="form-control"
                    onChange={handleInputChange}
                    disabled={!isEditing}
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>

              {/* Buttons */}
              <div className="row mt-4">
                <div className="col-md-12 d-flex flex-wrap gap-3">
                  {isEditing ? (
                    <>
                      <button
                        type="button"
                        className="th-btn btn-outline-secondary"
                        onClick={() => setIsEditing(false)}
                      >
                        Cancel <i className="fas fa-arrow-right ms-2" />
                      </button>

                      <button
                        type="button"
                        className="th-btn"
                        onClick={handleSubmit}
                        style={{ background: "green" }}
                      >
                        {
                          Loading ? (<>
                            <div className="d-flex gap-2 justify-content-center  align-items-center">
                              Save...
                              <i className="fas fa-arrow-right ms-2" />
                              <SubLoading />

                            </div>
                          </>)
                            : (<>
                              Save
                              <i className="fas fa-arrow-right ms-2" />
                            </>
                            )}
                      </button>

                    </>
                  ) : (
                    <button
                      type="button"
                      className="th-btn"
                      onClick={() => {
                        setFormData({
                          first_name: data?.first_name || "",
                          last_name: data?.last_name || "",
                          mobile_no: data?.mobile_no || "",
                          user_gender: data?.user_gender || "",
                        });
                        setIsEditing(true);
                      }}
                    >
                      <FiEdit size={18} className="me-2" />
                      Edit Profile <i className="fas fa-arrow-right ms-2" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <OrderHistory />
        </Container>
      </Wrapper>


      {/* this is a model  */}









    </>
  );
};
export default Profile;

const Container = styled.div`
  padding: 2rem 1rem;
  max-width: 60rem;
  margin: auto;
`;


const Header = styled.div`
  display: flex;
  align-items: center;
`;

const ProfilePicture = styled.img`
  width: 10rem;
  height: 10rem;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #e0e0e0;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
`;

const UserInfo = styled.div`
  flex: 1;
  min-width: 260px;

  h2 {
    font-size: 1.8rem;
    margin-bottom: 0.5rem;
  }

  h3 {
    font-size: 1.2rem;
    margin: 0.5rem 0;
    color: #333;
  }

  p {
    margin: 0.25rem 0;
    font-size: 1rem;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 0.6rem 0.8rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  font-size: 1rem;
`;

const StyledSelect = styled.select`
  width: 100%;
  padding: 0.6rem 0.8rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  font-size: 1rem;
`;

const EditButton = styled.button`
  background-color: #007bff;
  color: white;
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }
`;

const SaveButton = styled(EditButton)`
  background-color: #28a745;
  margin-left: 1rem;

  &:hover {
    background-color: #1e7e34;
  }
`;

const Wrapper = styled.section`
@media screen and (max-width: 576px) {
  img {
    width: 100px !important;
    height: 100px !important;
  }

  h3, p {
    font-size: 16px;
  }
}

`;
const CancelButton = styled(EditButton)`
  background-color: #6c757d;

  &:hover {
    background-color: #5a6268;
  }

`;
